module.exports = __webpack_public_path__ + "static/media/preloader.0fbed816.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/ImageInput/assets/preloader.svg
// module id = 1208
// module chunks = 0